import { parseCurrency } from '@helper/parseCurrency'

import {
  getStatus,
  toCoverLocaleString,
  toLocaleString,
  toLocaleString2,
  toLocaleString3
} from '../strings'

export const parsePurchaseMrpScheduledData = (data: any[]): any[] => {
  const res = []

  // Mesmo critério do parser anterior: ignora itens sem estoque/fornecedor
  const validData = data.filter(
    item =>
      !!item.estoque &&
      !!item.estoque.produtoFornecedor &&
      !!item.estoque.produtoFornecedor.fornecedor
  )

  for (const item of validData) {
    // Para compra programada, utilizamos os dados da estrutura compraProgramaRecomendada e compraProgramaDesejada
    const recomendada = item.compraProgramaRecomendada || {}
    const desejada = item.compraProgramaDesejada || {}
    const desejadaData = item.desejada || {}

    res.push({
      'centro-id': item.estoque?.loja ? item.estoque?.loja?.id : 0,
      'centro-nome': item.estoque?.loja ? item.estoque?.loja?.descricao : '',

      'produto-id': item.estoque?.produtoFornecedor
        ? item.estoque?.produtoFornecedor?.produto?.id
        : 0,
      'produto-categoria-compacta':
        item.estoque?.categoriaCompactaDescricao?.toUpperCase() || '',
      'produto-mundo': item.estoque?.mundoDescricao?.toUpperCase() || '',
      'produto-material': item.estoque?.produtoFornecedor
        ? item.estoque?.produtoFornecedor?.produto?.descricao
        : '',
      'produto-categoria': item.estoque?.produtoFornecedor
        ? item.estoque?.produtoFornecedor?.produto?.categoria?.descricao
        : '',
      'produto-curva-abc': item.estoque?.curvaABC || '',
      'produto-curva-abc-empresa': item.estoque?.curvaABCEmpresa || '',
      'produto-status': item.estoque?.textoStatus || '',
      'produto-lote': toLocaleString3(
        item.estoque?.produtoFornecedor?.quantidadePacote || 0
      ),
      'produto-grupo-separacao':
        item.estoque?.produtoFornecedor?.produto?.grupoCarga?.descricao || '',

      'fornecedor-id': item.estoque?.produtoFornecedor?.fornecedor
        ? item.estoque?.produtoFornecedor?.fornecedor?.id
        : 0,
      'fornecedor-nome': item.estoque?.produtoFornecedor?.fornecedor
        ? item.estoque?.produtoFornecedor?.fornecedor?.descricao
        : '',

      // Dados de recomendação da compra programada
      'recomendacao-pedidos': toLocaleString(recomendada.numeroDePedidos || 0),
      'recomendacao-quantidade': toLocaleString2(recomendada.totalPedidos || 0),
      'recomendacao-peso': toLocaleString(recomendada.pesoTotal || 0),
      'recomendacao-volume': toLocaleString(recomendada.volumeTotal || 0),
      'recomendacao-custo': toLocaleString(recomendada.custoTotal || 0),
      'recomendacao-cobertura-media': toLocaleString(
        desejada.coberturaMedia || 0
      ),
      'recomendacao-tipo-alerta': getStatus(item.motivoRecomendacao || 0),
      'recomendacao-nivel-servico': (
        desejadaData?.nivelServico * 100 || 0
      ).toLocaleString('pt-BR', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
      }),
      'recomendacao-inicio': recomendada.inicio
        ? new Date(recomendada.inicio).toLocaleDateString('pt-BR')
        : '',
      'recomendacao-fim': recomendada.fim
        ? new Date(recomendada.fim).toLocaleDateString('pt-BR')
        : '',

      // Dados de compra desejada programada
      'compra-peso': toLocaleString(desejada.pesoTotal || 0),
      'compra-volume': toLocaleString(desejada.volumeTotal || 0),
      'compra-desejada':
        (item.ajustadoPeloFaturamentoMinimo === true ? 'T' : 'F') +
        parseCurrency({
          value: desejada.totalPedidos || 0,
          country: 'pt-br',
          minFraction: 0,
          maxFraction: 0
        }),
      'compra-custo': toLocaleString(desejada.custoTotal || 0),
      'compra-custo-unit': toLocaleString(
        item.estoque?.custoUnitarioFatorConversao || 0
      ),
      'compra-nivel-servico': (
        desejadaData?.nivelServico * 100 || 0
      ).toLocaleString('pt-BR', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
      }),
      'compra-inicio': desejada.inicio
        ? new Date(desejada.inicio).toLocaleDateString('pt-BR')
        : '',
      'compra-fim': desejada.fim
        ? new Date(desejada.fim).toLocaleDateString('pt-BR')
        : '',

      // Dados de estoque (mesmo para compra programada)
      'estoque-max': toLocaleString2(item.estoque?.maximo || 0),
      'estoque-cd': toLocaleString2(
        item.estoque?.disponivelReservadoCentroDistribuicao || 0
      ),
      'estoque-reservado': toLocaleString2(
        item.estoque?.quantidadeReservada || 0
      ),
      'estoque-id': item.estoque?.id || 0,
      'estoque-disponivel': parseCurrency({
        value: item.estoque?.disponivel || 0,
        country: 'pt-br',
        minFraction: 0,
        maxFraction: 0
      }),
      'estoque-minimo': parseCurrency({
        value: item.estoque?.estoqueMinimo || 0,
        country: 'pt-br',
        minFraction: 0,
        maxFraction: 0
      }),
      'estoque-ordenado': parseCurrency({
        value: item.estoque?.ordenado || 0,
        country: 'pt-br',
        minFraction: 0,
        maxFraction: 0
      }),
      'estoque-periodo-revisao': item.estoque?.periodoRevisao || 0,
      'estoque-tempo-espera': item.estoque?.tempoDeEspera || 0,
      'estoque-total': parseCurrency({
        value: item.estoque?.total || 0,
        country: 'pt-br',
        minFraction: 0,
        maxFraction: 0
      }),
      'estoque-total-ordenado': parseCurrency({
        value: item.estoque?.totalMaisOrdenado || 0,
        country: 'pt-br',
        minFraction: 0,
        maxFraction: 0
      }),

      // Simulação DRP específica para compra programada
      'simulacao-demanda-media': toLocaleString(
        recomendada.demandaMediaDiaria || 0
      ),
      'simulacao-cobertura-media': toCoverLocaleString(
        recomendada.coberturaMedia || 0
      ),
      'simulacao-numero-pedidos': toLocaleString2(
        recomendada.numeroDePedidos || 0
      ),

      // Cobertura e outros dados específicos
      'cobertura-alvo': toCoverLocaleString(item.coberturaAlvo || 0),
      'cobertura-desejada': toCoverLocaleString(item.coberturaDesejada || 0),
      diferenca: item.diferenca || 0,
      'alcancou-recomendacao': item.alcancouRecomendacaoDesejada
        ? 'Sim'
        : 'Não',
      'acima-tolerancia': item.acimaToleranciaPermitida ? 'Sim' : 'Não',

      // Campos adicionais
      'compra-pedidos': toLocaleString(
        item.compraProgramaDesejada?.numeroDePedidos || 0
      ),
      'compra-quantidade': toLocaleString2(
        item.compraProgramaDesejada?.totalPedidos || 0
      ),
      'produto-lead-time': item.estoque?.tempoDeEspera || 0,
      'produto-intervalo-compra': item.estoque?.periodoRevisao || 0,
      'compra-cobertura-média': toLocaleString(
        item.compraProgramaDesejada?.coberturaMedia || 0
      ),
      'estoque-transito': toLocaleString2(item.estoque?.ordenadoCompra || 0),
      'estoque-outros': toLocaleString2(
        item.estoque?.estoquesIndisponiveis?.Luizinho || 0
      ),
      'estoque-venda-diaria': toLocaleString(
        item.compraProgramaRecomendada?.demandaMediaDiaria || 0
      ),
      'gerente-produto-id': item.estoque?.gerenteProdutoId || 0,
      'gerente-produto-desc': item.estoque?.gerenteProdutoDescricao || '',
      'produto-sub-categoria':
        item.estoque?.subCategoriaDescricao?.toUpperCase() || '',
      'vmm-primeira-entrada': item.previsaoDemanda?.primeiraEntradaDoProduto
        ? new Date(
            item.previsaoDemanda.primeiraEntradaDoProduto.split('T')[0] +
              'T12:00:00'
          ).toLocaleDateString('pt-BR')
        : '—',
      'vmm-janela-efetiva': item.previsaoDemanda?.janelaEfetivaDeDias
        ? `${item.previsaoDemanda.janelaEfetivaDeDias} dias`
        : '—',
      'calculo-saida-diaria':
        item.previsaoDemanda?.etapasCalculoSaidaMediaDiaria || [],
      'calculo-quantidade': item.etapasCalculoQuantidadeRecomendada || []
    })
  }

  return res
}
